var render = function render(){var _vm=this,_c=_vm._self._c;return _c('availability-full-calendar',{attrs:{"year":_vm.year,"month":_vm.month,"dates":_vm.dates,"physician":_vm.physician,"practice":_vm.practice,"showCancelled":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }